// Common analytics events used across multiple components

import { sendAnalyticsEvent } from "./analytics";

/** @deprecated Use a string label directly for new events. */
export type CtaClickedArea =
  | "primary-dark"
  | "primary-white"
  | "primary-purple"
  | "text_link"
  | "logo";

// Module-level result page context — set once by ResultsPage, auto-included
// in every trackCtaClick call so child components don't need to drill props.
let _pageVariant: string | undefined;
let _resultOutcome: "likely" | "unlikely" | undefined;

/** Call from ResultsPage on mount to set analytics context for all CTA events. */
export function setResultPageContext(
  pageVariant: string,
  resultOutcome: "likely" | "unlikely",
): void {
  _pageVariant = pageVariant;
  _resultOutcome = resultOutcome;
}

/** Reset result page context (e.g. when navigating away). Exported for testing. */
export function clearResultPageContext(): void {
  _pageVariant = undefined;
  _resultOutcome = undefined;
}

export interface CtaClickEvent {
  componentName: string;
  /** Semantic area / CTA label. Accepts any string; legacy values are typed above. */
  clickedArea: string;
  clickedText: string;
  clickedUrl?: string;
}

export const trackCtaClick = ({
  componentName,
  clickedArea,
  clickedText,
  clickedUrl = "",
}: CtaClickEvent): void => {
  const payload: Record<string, unknown> = {
    event: "cta_click",
    componentName,
    clickedArea,
    clickedText,
    clickedUrl,
  };
  if (_pageVariant !== undefined) payload.pageVariant = _pageVariant;
  if (_resultOutcome !== undefined) payload.resultOutcome = _resultOutcome;
  sendAnalyticsEvent(payload);
};
